import { useQuery } from "@tanstack/react-query"
import { listPayTransactionHistory } from "services/apiPayments";

const useGetPayTransactionHistory = (page,size,searchTerm,fromDate,toDate,orgFilter) => {

  const {isPending,isSuccess,isError,error,data} = useQuery({
    queryKey:['payTransactionHistory',page,size,searchTerm,fromDate,toDate,orgFilter],
    queryFn: ()=> listPayTransactionHistory(page,size,searchTerm,fromDate,toDate,orgFilter),
    keepPreviousData:true,
    staleTime: 2 * 60 * 60 * 1000
  })

  return{isPending,isSuccess,isError,error,data}
}

export default useGetPayTransactionHistory
